export const REMINDER_LOG_STATUSES = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  EMAIL_FAILED: 'EMAIL_FAILED',
  NOTIFICATION_FAILED: 'NOTIFICATION_FAILED',
  WORKER_FAILED: 'WORKER_FAILED',
  SKIPPED: 'SKIPPED'
};

export const REMINDER_LOG_STATUSES_LABELS = {
  [REMINDER_LOG_STATUSES.SUCCESS]: 'Success',
  [REMINDER_LOG_STATUSES.FAILED]: 'Failed',
  [REMINDER_LOG_STATUSES.EMAIL_FAILED]: 'Email failed',
  [REMINDER_LOG_STATUSES.NOTIFICATION_FAILED]: 'Notification failed',
  [REMINDER_LOG_STATUSES.WORKER_FAILED]: 'Worker failed',
  [REMINDER_LOG_STATUSES.SKIPPED]: 'Skipped',
};

export const REMINDER_LOG_STATUSES_FILTER_OPTIONS = [
  { value: 'ALL', label: 'All' },
  { value: REMINDER_LOG_STATUSES.SUCCESS, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.SUCCESS] },
  { value: REMINDER_LOG_STATUSES.FAILED, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.FAILED] },
  { value: REMINDER_LOG_STATUSES.EMAIL_FAILED, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.EMAIL_FAILED] },
  { value: REMINDER_LOG_STATUSES.NOTIFICATION_FAILED, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.NOTIFICATION_FAILED] },
  { value: REMINDER_LOG_STATUSES.WORKER_FAILED, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.WORKER_FAILED] },
  { value: REMINDER_LOG_STATUSES.SKIPPED, label: REMINDER_LOG_STATUSES_LABELS[REMINDER_LOG_STATUSES.SKIPPED] },
];
